import useTimesheetsQueryParams from 'containers/timesheets/hooks/useTimesheetsQueryParams';
import { useMemo } from 'react';
import { getApolloArchivedTimestampComparison } from 'utils/archivedUtils';

export default function useTimesheetsArchivedStatusComparison() {
  const { archivedStatus } = useTimesheetsQueryParams();
  return useMemo(() => getApolloArchivedTimestampComparison(archivedStatus), [archivedStatus]);
}
